import { Box, Stack, Text } from "@chakra-ui/react";
import AboutMe from "./components/AboutMe/About";
import ContactUs from "./components/ContactUs/ContactUs";
import GithubCalendar from "./components/github/GithubCalendar";
import NameImg from "./components/NameImg/NameImg";
import Navbar from "./components/Navbar/Navbar";
import Particle from "./components/Particle/Particle";
import Projects from "./components/Projects/Projects";
import Skills from "./components/Skills/Skills";
import "./App.css";

function App() {
  return (
    <div>
      <Particle />
      <Navbar />
      <Stack gap={{ lg: "120px", md: "80px", sm: "40px" }} mx="3%">
        <NameImg />
        <AboutMe />
        <Skills />
        <Projects />
        <GithubCalendar />
        <ContactUs />
      </Stack>
      <Text
        fontSize={["11px", "12px", "14px"]}
        color="#fff"
        textAlign="center"
        mt="15px"
      >
        Created by Faizal Siddiqui with ❤️{" "}
      </Text>
    </div>
  );
}

export default App;
